// import { createSelector } from 'reselect'
import moment from 'moment'

export const getShowUndeliveredOrderLines = state => state.getIn(['uiStore', 'showUndeliveredOrderLines'])
export const getDailyReportDate = state => state.getIn(['uiStore', 'dailyReportDate'])
export const getDailyReportProduct = state => state.getIn(['uiStore', 'dailyReportProduct'])
export const getDailyReportVariation = state => state.getIn(['uiStore', 'dailyReportVariation'])
export const getOrdersMap = state => state.getIn(['ordersStore', 'orders'])
export const getTeamsMap = state => state.getIn(['teamsStore', 'teams']).sort((a, b) => a.get('name').localeCompare(b.get('name')))
export const getCurrentOrderMap = state => state.getIn(['ordersStore', 'currentOrder'])
export const getTeamIdMap = state => state.getIn(['ordersStore', 'teamId'])
export const getProductsMap = state => state.getIn(['productsStore', 'products'])

export const getTeamById = state => teamId => state.getIn(['teamsStore', 'teams']).find((team) => team.get('id') === teamId)
export const getTeamNameById = state => teamId => {
  const team = getTeamById(state)(teamId)
  return team ? team.get('name') : teamId
}
export const isDeleteOrderDialogVisible = state => state.getIn(['ordersStore', 'deleteOrderDialogVisible'])

const getVariations = state => getProductsMap(state).map(product => product.get('variations')).reduce((a, b) => a.concat(b))

export const getCurrentOrderTeamMap = state => state.getIn(['ordersStore', 'currentOrder', 'team', 'id'])
export const getCurrentOrderCustomerMap = state => state.getIn(['ordersStore', 'currentOrder', 'customerName'])
export const getCurrentOrderOrderLinesMap = state => state.getIn(['ordersStore', 'currentOrder', 'orderLines'])
export const getCurrentOrderLineMap = state => state.getIn(['ordersStore', 'currentOrderLine'])
const getCurrentVariationId = state => getCurrentOrderLineMap(state).getIn(['variation', 'id'])
export const getCurrentVariationFieldsMap = state => {
  let currentVariation = getVariations(state).find(v => v.get('id') === getCurrentVariationId(state))
  return currentVariation.get('fields')
}
export const getShowPaidOrdersMap = state => state.getIn(['ordersStore', 'showPaidOrders'])
export const getShowUndoneOrdersMap = state => state.getIn(['ordersStore', 'showUndoneOrders'])
export const getShowDeliveredOrdersMap = state => state.getIn(['ordersStore', 'showDeliveredOrders'])
export const getShowingAllOrders = state => state.getIn(['ordersStore', 'showingAllOrders'])
export const getSearchText = state => state.getIn(['ordersStore', 'searchText'])
export const getOrderById = state => orderId => state.getIn(['ordersStore', 'orders']).find((order) => order.get('id') === orderId)

//suma lo acumulado por día
/*export const getOrdersAmountByDate = state => date => getOrdersMap(state).filter(
 order => moment(order.get('date')).startOf('day').format() === moment(date).startOf('day').format() && (order.get('paid'))
 ).map(
 order => order.get('orderLines').map(
 line => (line.get('unitPrice') * line.get('quantity'))
 ).reduce((a, b) => a + b, 0)
 ).reduce((a, b) => a + b, 0);*/

//returns paid orders amount by hour of the last 4 days
export const getOrdersAmountByHour = state => getOrdersMap(state).filter(
  order => moment(order.get('date')).startOf('day').format() >= moment().subtract(4, 'd').startOf('day').format() && (order.get('paid'))
)

//Esto está roto. Fallaba por culpa de esto la pantalla de produccion
export const getFilteredOrdersMap = state => {
  let orders = state.getIn(['ordersStore', 'orders'])
  if (getShowPaidOrdersMap(state)) {
    orders = orders.filter((order) => order.get('paid') === getShowPaidOrdersMap(state))
  }
  if (getShowDeliveredOrdersMap(state)) {
    orders = orders.filter((order) => order.get('delivered') === getShowDeliveredOrdersMap(state))
  }
  if (getShowUndoneOrdersMap(state)) {
    orders = orders.filter((order) => order.get('done') === false)
  }
  return orders
}

export const getShowMainMenuMap = state => state.getIn(['uiStore', 'showMainMenu'])

export const getOrderStatus = (order) => {
        const finishedOrderLines = order.orderLines
            .map(ol => ol.status === 'DONE'? 1 : 0)
            .reduce((a,b) => a + b, 0);
        if (finishedOrderLines === order.orderLines.length) return 'DONE'
        if (order.orderLines.filter(ol => ol.status !== 'TODO').length > 0) return 'DOING'
        return 'TODO'
    }


// WEBPACK FOOTER //
// ./src/redux/selectors.js